import { render, staticRenderFns } from "./DiskSidebar.vue?vue&type=template&id=40265b9b&scoped=true&"
import script from "./DiskSidebar.vue?vue&type=script&lang=js&"
export * from "./DiskSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DiskSidebar.vue?vue&type=style&index=0&id=40265b9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40265b9b",
  null
  
)

export default component.exports